import { application } from "./application"
import HelloController from "./hello_controller"
import FollowAlongController from "./follow_along_controller"
import InfiniteScrollController from "./infinite_scroll_controller"

application.register("hello", HelloController)
application.register("follow-along", FollowAlongController)
application.register("infinite-scroll", InfiniteScrollController)
